export const GUIDANCE_NOTE_DEFAULT_TITLE = 'Indicaciones:'
